import { Typography } from "shared/ui/components/Typography";

import styles from "./InfoCard.module.scss";

const InfoCard = () => {
  return (
    <div className={styles.root}>
      <Typography variant="h2" weight="semiBold" className={styles.title}>
        INFORMATIONEN ZUR VORSTEHENDEN BERECHNUNG UND HAFTUNGSAUSSCHLUSS
      </Typography>
      <Typography variant="h3" weight="semiBold" className={styles.subtitle}>
        Allgemeines
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        Immobilienerwerbe dienten in der Vergangenheit dazu, Kaufkraftverlust
        und Inflation langfristig entgegenzuwirken. Zu beachten gilt allerdings,
        dass Immobilienpreise gegenwärtig stark fluktuieren. Vor diesem
        Hintergrund kann insbesondere der frühzeitige Weiterverkauf von
        Immobilien angesichts der mit der Veräußerung eines Grundstücks
        entstehenden (Neben-)Kosten zu einer negativen Vermögensentwicklung
        führen. Da unsererseits künftige wirtschaftliche Entwicklungen, aber
        auch sonstige Umstände rechtlicher oder tatsächlicher Art, wie etwa
        Gesetzesänderungen, Änderungen der Rechtsprechung oder der
        Verwaltungspraxis sowie Änderungen Ihrer persönlichen wirtschaftlichen
        Verhältnisse, nicht vorhergesehen werden können, weisen wir Sie hiermit
        auf den nachfolgenden Haftungsausschluss hin.
      </Typography>
      <Typography variant="h3" weight="semiBold" className={styles.subtitle}>
        Haftungsausschluss
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        {`1. Für die Richtigkeit der in dieser Angebotserrechnung verwendeten,
        projektspezifischen Angaben, die allein auf den uns zur Verfügung
        gestellten Informationen des Verkäufers der Immobilie beruhen, wird
        jegliche Haftung ausgeschlossen. Der vorstehende Haftungsausschluss gilt
        jedoch nicht bei Vorsatz und grober Fahrlässigkeit von gesetzlichen
        Vertretern oder Erfüllungsgehilfen und bei schuldhafter Verletzung von
        wesentlichen Vertragspflichten (Kardinalpflichten).`}
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        {`2. Die vorstehende Angebotserrechnung dient lediglich als Muster und
        stellt weder eine Form rechtlicher noch steuerlicher Beratungstätigkeit
        dar. Wir weisen insoweit insbesondere auf die nachfolgenden
        Klarstellungen hin:`}
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        {`a) Eine Übertragbarkeit dieser Musterberechnung auf Ihre finanzielle
        Situation wird nicht garantiert; für das Erreichen der von Ihnen
        angestrebten wirtschaftlichen und steuerlichen Ziele wird folglich keine
        Gewähr übernommen.`}
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        {` b) Die in hiesiger Unterlage dargestellten steuerlichen Berechnungen
        erfolgen auf der Grundlage, dass die Immobilienanlage nicht dem
        Anwendungsbereich des § 15b EStG unterliegt. Auch aufgrund der weiteren
        steuerlichen Besonderheiten des EStG ist die Musterberechnung nicht für
        jede Einkommenssituation geeignet und sollte daher Ihrerseits bzw. durch
        einen Steuerberater auf hinreichende Eignung geprüft werden.`}
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        {`c) Die in der Musterberechnung dargelegten Finanzierungskonditionen
        stellen kein verbindliches Finanzierungsangebot dar. Letzteres richtet
        sich stets nach dem Ihrerseits individuell mit Ihrem Kreditinstitut
        entwickelten Finanzierungsplan. Der vorstehende Haftungsausschluss gilt
        auch für etwaige Abweichungen zwischen dieser Musterberechnung und Ihrem
        Finanzierungsplan.`}
      </Typography>
      <Typography variant="bodyM" className={styles.text}>
        {`3. Etwaige Abweichungen von dieser Musterberechnung berühren weder die
        Wirksamkeit noch den konkreten Inhalt und Umfang des
        Grundstückskaufvertrags.`}
      </Typography>
    </div>
  );
};

export default InfoCard;
